import styled from 'styled-components'

export const ComputationContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
`

export const Right = styled.div`
  margin-left: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const Figures = styled.span`
  font-weight: 700;
`
